const categories = [
  {
    id: 4,
    name: 'Phone & Tablets',
    image: 'https://images.pexels.com/photos/4300393/pexels-photo-4300393.png?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    keyword: 'phone, tablet, samsung, iphone, ios, android'
  },
  {
    id: 5,
    name: 'Computing',
    image: 'https://images.pexels.com/photos/3550484/pexels-photo-3550484.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    keyword: 'computer, laptop, desktop, windows, macbook'
  },
  {
    id: 6,
    name: 'Electronics',
    image: 'https://images.pexels.com/photos/3178938/pexels-photo-3178938.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    keyword: 'electric, standing fan, speaker'
  },
  {
    id: 7,
    name: 'Fashion',
    image: 'https://images.pexels.com/photos/2703433/pexels-photo-2703433.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    keyword: 'fashion, cloth, shirt, shoes, bag'
  },
  {
    id: 3,
    name: 'Home & Office',
    image: 'https://images.pexels.com/photos/4050318/pexels-photo-4050318.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    keyword: 'home, office'
  },
  {
    id: 1,
    name: 'Supermarket',
    image: 'https://images.pexels.com/photos/6280415/pexels-photo-6280415.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    keyword: 'grocery'
  },
  {
    id: 2,
    name: 'Health & Beauty',
    image: 'https://images.pexels.com/photos/775032/pexels-photo-775032.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    keyword: 'beauty'
  },
  {
    id: 8,
    name: 'Baby Products',
    image: 'https://images.pexels.com/photos/459957/pexels-photo-459957.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    keyword: 'baby'
  },
  {
    id: 9,
    name: 'Gaming',
    image: 'https://images.pexels.com/photos/159438/android-tv-game-controller-game-controller-video-game-controller-android-game-controller-159438.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    keyword: 'gaming, controller, pad'
  },
  {
    id: 10,
    name: 'Sporting Goods',
    image: 'https://images.pexels.com/photos/159607/basketball-player-girls-basketball-girl-159607.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    keyword: 'sport, football, jersey'
  },
  {
    id: 11,
    name: 'Automobile',
    image: 'https://images.pexels.com/photos/1231643/pexels-photo-1231643.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    keyword: 'automobile, car'
  },
  {
    id: 12,
    name: 'Others',
    image: 'https://images.pexels.com/photos/5310566/pexels-photo-5310566.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    keyword: 'all'
  }
];

export default categories;
